import TEMPLATE_URL from "emun.invoice/picker/invoice-picker.htm";
import controller from "emun.invoice/picker/invoice-picker.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "lg",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  placement = undefined, // "right",
  title = "Select invoice(s)...",
  subTitle = "Add to invoice list",
  view = "table",
  single = false,
  viewSelections = false,
  okButtonText = "OK",
  closeButtonText = single ? "Close" : "Cancel",
  selected = {},
  criteria = {},
  onToggle = NOOP,
  onInvoiceSelected = NOOP,
  onInvoiceDeselected = NOOP
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    console: console.debug(templateUrl, {
      placement,
      size,
      backdrop,
      title,
      view
    }),
    placement,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        subTitle,
        onInvoiceSelected,
        onInvoiceDeselected,
        onToggle,
        criteria,
        view,
        viewSelections,
        okButtonText,
        closeButtonText,
        single,
        selected
      })
    }
  }).result;
